import CreationToolCutOutMode from './cut-out-mode'
import CreationToolOutputType from './output-type'
import CreationToolStep from './steps'
import CreationToolWelcomeButton from './welcome-button'

namespace CreationToolGAEvent {
    /**
     * Returns the GA event's category for a button on the creation tool's welcome screen.
     */
    export function welcomeButtonCategory(type: CreationToolWelcomeButton): string {
        switch (type) {
            case CreationToolWelcomeButton.Gif:
                return 'gif maker'
            case CreationToolWelcomeButton.Sticker:
                return 'sticker maker'
            case CreationToolWelcomeButton.Backdrop:
                return 'backdrop'
            default:
                return ''
        }
    }

    /**
     * Returns the GA event's label value when moving between sticker-maker steps.
     */
    export function nextStepLabel(step: CreationToolStep | undefined): string {
        switch (step) {
            case CreationToolStep.Animate:
                return 'Remove Background'
            case CreationToolStep.Upload:
                return 'Motion Filter Applied'
            case CreationToolStep.Decorate:
                return ''
            case CreationToolStep.CutOut:
                return ''
            case CreationToolStep.VideoTrim:
                return ''
            case undefined:
                throw 'Something went wrong.'
        }
    }

    /**
     * Returns the GA event category based on the creation tool's output type.
     */
    export function outputTypeCategory(category: CreationToolOutputType): string {
        switch (category) {
            case CreationToolOutputType.Sticker:
                return 'sticker maker'
            case CreationToolOutputType.Gif:
                return 'gif maker'
            case CreationToolOutputType.Backdrop:
                return 'backdrop'
            case CreationToolOutputType.Video:
                return 'video'
        }
    }

    /**
     * Returns the GA event action based on a creation tool action.
     */
    export function creationToolAction(action: CreationToolStep | undefined): string {
        switch (action) {
            case CreationToolStep.CutOut:
                return 'Cut out'
            case CreationToolStep.Animate:
                return 'Animate'
            case CreationToolStep.Decorate:
                return ''
            case CreationToolStep.Upload:
                return ''
            case CreationToolStep.VideoTrim:
                return ''
            case undefined:
                throw 'Something went wrong.'
        }
    }

    /**
     * Returns the GA event label based on a creation tool cutout mode.
     */
    export function creationToolCutoutModeLabel(cutoutMode: CreationToolCutOutMode): string {
        switch (cutoutMode) {
            case CreationToolCutOutMode.Erase:
                return 'Erase'
            case CreationToolCutOutMode.Lasso:
                return 'Lasso'
            case CreationToolCutOutMode.MagicWand:
                return 'Magic Wand'
            case CreationToolCutOutMode.Paint:
                return 'Paint'
        }
    }
}

export default CreationToolGAEvent
